<template>
  <b-modal
    no-close-on-backdrop
    centered
    ok-only
    size="lg"
    ok-title="Fechar"
    ok-variant="danger"
    v-model="open"
    :title="`${fields.id} - Detalhes do lojista ${
      shopkeeper.razao_social || ''
    }`"
    :busy="loading"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12" class="mb-4">
        <b-row>
          <b-col cols="4">
            <Info
              label="Razão social"
              :value="shopkeeper.razao_social || 'Sem informação'"
            />
          </b-col>
          <b-col cols="4">
            <Info
              label="Nome fantasia"
              :value="shopkeeper.nome_fantasia || 'Sem informação'"
            />
          </b-col>
          <b-col cols="4">
            <Info
              label="Nome responsável"
              :value="shopkeeper.nome_responsavel || 'Sem informação'"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" class="mb-4">
        <b-row>
          <b-col cols="4">
            <Info label="RG" :value="shopkeeper.rg || 'Sem informação'" />
          </b-col>
          <b-col cols="4">
            <Info label="CPF" :value="shopkeeper.cpf || 'Sem informação'" />
          </b-col>
          <b-col cols="4">
            <Info label="CNPJ" :value="shopkeeper.cnpj || 'Sem informação'" />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12">
        <b-row>
          <b-col cols="4">
            <Info
              label="E-mail"
              :value="shopkeeper.email || 'Sem informação'"
            />
          </b-col>
          <b-col cols="4">
            <Info
              label="Celular / Whatsapp"
              :value="shopkeeper.celular || 'Sem informação'"
            />
          </b-col>
          <b-col cols="4">
            <Info
              label="Telefone"
              :value="shopkeeper.telefone || 'Sem informação'"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12" class="text-center mb-4">
        <span class="font-weight-bold fs-18">Endereço</span>
      </b-col>
      <b-col cols="12">
        <b-row class="mb-4">
          <b-col cols="4">
            <Info label="CEP" :value="shopkeeper.cep || 'Sem informação'" />
          </b-col>
          <b-col cols="8">
            <Info
              label="Endereço"
              :value="shopkeeper.endereco || 'Sem informação'"
            />
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col cols="4">
            <Info
              label="Número"
              :value="shopkeeper.numero || 'Sem informação'"
            />
          </b-col>
          <b-col cols="4">
            <Info
              label="Bairro"
              :value="shopkeeper.bairro || 'Sem informação'"
            />
          </b-col>
          <b-col cols="2">
            <Info
              label="Cidade"
              :value="(shopkeeper.cidade || {}).nome || 'Sem informação'"
            />
          </b-col>
          <b-col cols="2">
            <Info
              label="Estado"
              :value="(shopkeeper.estado || {}).nome || 'Sem informação'"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <Info
              label="Complemento"
              :value="shopkeeper.complemento || 'Sem informação'"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12" class="text-center mb-4">
        <span class="font-weight-bold fs-18">Contato Financeiro</span>
      </b-col>
      <b-col cols="12">
        <b-row class="mb-4">
          <b-col cols="6">
            <Info
              label="Nome do Responsável"
              :value="(shopkeeper.financeiro || {}).nome || 'Sem informação'"
            />
          </b-col>
          <b-col cols="6">
            <Info
              label="E-mail do Responsável"
              :value="(shopkeeper.financeiro || {}).email || 'Sem informação'"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <Info
              label="Telefone / Celular"
              :value="(shopkeeper.financeiro || {}).celular || 'Sem informação'"
            />
          </b-col>
          <b-col cols="6">
            <Info
              label="Ramal"
              :value="(shopkeeper.financeiro || {}).ramal || 'Sem informação'"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import makeToast from '@/mixins/makeToast';

import Info from '../Inputs/Info.vue';

export default {
  name: 'ShopkeeperDetails',
  mixins: [makeToast],
  data() {
    return {
      loading: false,
      open: false,
      fields: this.defaultShopkeeper(),
    };
  },
  computed: {
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
      shopkeeper: (state) => (state.lojista || [])[0] || {},
    }),
    ...mapGetters('general', ['getImagesAddress']),
  },
  methods: {
    ...mapActions(['showLojista']),
    toggleOpen({ shopkeeperId = 0 }) {
      this.clean();

      this.open = !this.open;
      this.fields.id = shopkeeperId;

      this.get();
    },
    async get() {
      if (this.loading || !this.fields.id) return;

      this.loading = true;

      this.showLojista(this.fields.id)
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },
    clean() {
      this.fields = this.defaultShopkeeper();
    },
    defaultShopkeeper() {
      return {
        id: '',
      };
    },
  },
  components: {
    Info,
  },
};
</script>
